import {} from '../../Summary.model';
import { Box } from '../../../box';
import styles from '../../Summary.module.css';
import { Text } from '../../../../foundations';
import { Icon } from '../../../../foundations';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { SummaryTotalProps } from '../summary-total/SummaryTotal';

export type SummaryItemProps = {
	icon?: 'go' | 'return';
	iconReturn?: boolean;
	titleColor?: string;
	children?: ReactNode;
	title?: string;
	total?: SummaryTotalProps;
};

export const SummaryItem = (props: SummaryItemProps) => {
	const { icon, title, titleColor, children, total } = props;
	return (
		<Box className={styles.summary_item}>
			{title && (
				<Box className={styles.summary_display_row}>
					{icon && (
						<Icon
							className={clsx(styles.summary_icon, {
								[styles.summary_icon_go]: icon === 'go',
								[styles.summary_icon_return]: icon === 'return'
							})}
							name="vuelos"
						></Icon>
					)}
					<Text
						className={icon && styles.summary_item_title}
						style={{ color: titleColor }}
						font="iberia-headline"
						size="sm-regular"
					>
						{title}
					</Text>
				</Box>
			)}
			{children}
			{total && (
				<Box className={styles.summary_item_box_total}>
					<Text className={styles.summary_text_fit} font="verdana" size="lg-bold">
						{total.title}
					</Text>
					<Text className={styles.summary_price_align} font="verdana" size="lg-bold">
						{total.price}
					</Text>
				</Box>
			)}
		</Box>
	);
};
SummaryItem.displayName = 'SummaryItem';
